import {doRequest} from '../../../helpers/network';
import {REQUEST_TYPE} from '../../../constants';
import {Revenue} from '../../../helpers/Urls';

// Action types
const UPLOAD_DOCUMENTS = 'UPLOAD_DOCUMENTS';
const UPLOAD_DOCUMENTS_COMPLETED = 'UPLOAD_DOCUMENTS_COMPLETED';
const UPLOAD_DOCUMENTS_FAILED = 'UPLOAD_DOCUMENTS_FAILED';

const FETCH_DOCUMENT_OPTIONS = 'FETCH_DOCUMENT_OPTIONS';
const FETCH_DOCUMENT_OPTIONS_COMPLETED = 'FETCH_DOCUMENT_OPTIONS_COMPLETED';
const FETCH_DOCUMENT_OPTIONS_FAILED = 'FETCH_DOCUMENT_OPTIONS_FAILED';

const FETCH_DOCUMENT_TRIP_OPTIONS = 'FETCH_DOCUMENT_TRIP_OPTIONS';
const FETCH_DOCUMENT_TRIP_OPTIONS_COMPLETED =
  'FETCH_DOCUMENT_TRIP_OPTIONS_COMPLETED';
const FETCH_DOCUMENT_TRIP_OPTIONS_FAILED = 'FETCH_DOCUMENT_TRIP_OPTIONS_FAILED';

// Upload documents action
export const uploadOrderDocuments = (formData) => {
  return async (dispatch) => {
    try {
      dispatch({type: UPLOAD_DOCUMENTS});

      const response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Revenue.uploadOrderDocumentsURL(),
        data: formData,
      });

      const {data, status} = response || {};
      if (status) {
        dispatch({type: UPLOAD_DOCUMENTS_COMPLETED, payload: data});
        return {success: true, message: data || 'Uploaded successfully'};
      } else {
        dispatch({
          type: UPLOAD_DOCUMENTS_FAILED,
          payload: {error: response?.message || 'Upload failed'},
        });
        return {success: false, message: response?.message || 'Upload failed'};
      }
    } catch (err) {
      console.log('Error uploading documents:', err);
      dispatch({
        type: UPLOAD_DOCUMENTS_FAILED,
        payload: {error: err.message},
      });
      return {
        success: false,
        message: err.message || 'Unexpected error occurred',
      };
    }
  };
};

// Fetch document options action
export const fetchDocumentOptions = () => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_DOCUMENT_OPTIONS});

      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Revenue.getDocumentOptionsURL(),
      });

      const {data, status} = response || {};
      if (status) {
        dispatch({type: FETCH_DOCUMENT_OPTIONS_COMPLETED, payload: data});
      } else {
        dispatch({
          type: FETCH_DOCUMENT_OPTIONS_FAILED,
          payload: {error: response?.message || 'Fetch failed'},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_DOCUMENT_OPTIONS_FAILED,
        payload: {error: err.message},
      });
    }

    return response;
  };
};

export const fetchDocumentTripOptions = () => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_DOCUMENT_TRIP_OPTIONS});

      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Revenue.getDocumentTripOptionsURL(),
      });

      const {data, status} = response || {};
      if (status) {
        dispatch({type: FETCH_DOCUMENT_TRIP_OPTIONS_COMPLETED, payload: data});
      } else {
        dispatch({
          type: FETCH_DOCUMENT_TRIP_OPTIONS_FAILED,
          payload: {error: response?.message || 'Fetch failed'},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_DOCUMENT_TRIP_OPTIONS_FAILED,
        payload: {error: err.message},
      });
    }

    return response;
  };
};

// Initial state
const INITIAL_STATE = {
  uploading: false,
  uploadError: null,
  documentData: null,
  loadingDocumentData: false,
  fetchOptionsError: null,
  loadingTripDocumentData: false,
  fetchTripOptionsError: null,
  tripDocumentData: null,
};

// Reducer
export default (state = INITIAL_STATE, action) => {
  const {type, payload} = action;

  switch (type) {
    // Upload reducers
    case UPLOAD_DOCUMENTS:
      return {...state, uploading: true, uploadError: null};
    case UPLOAD_DOCUMENTS_COMPLETED:
      return {
        ...state,
        uploading: false,
      };
    case UPLOAD_DOCUMENTS_FAILED:
      return {...state, uploading: false, uploadError: payload?.error};

    // Fetch document options reducers
    case FETCH_DOCUMENT_OPTIONS:
      return {...state, loadingDocumentData: true, fetchOptionsError: null};
    case FETCH_DOCUMENT_OPTIONS_COMPLETED:
      return {...state, loadingDocumentData: false, documentData: payload};
    case FETCH_DOCUMENT_OPTIONS_FAILED:
      return {
        ...state,
        loadingDocumentData: false,
        fetchOptionsError: payload?.error,
      };

    case FETCH_DOCUMENT_TRIP_OPTIONS:
      return {
        ...state,
        loadingTripDocumentData: true,
        fetchTripOptionsError: null,
      };
    case FETCH_DOCUMENT_TRIP_OPTIONS_COMPLETED:
      return {
        ...state,
        loadingTripDocumentData: false,
        tripDocumentData: payload,
      };
    case FETCH_DOCUMENT_TRIP_OPTIONS_FAILED:
      return {
        ...state,
        loadingTripDocumentData: false,
        fetchOTripptionsError: payload?.error,
      };

    default:
      return state;
  }
};
